import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

export const CONNECTOR_KEY_MASK = '••••••••••••••••••••••••••••';

export const CONNECTOR_KEY_REGENERATE_CONFIRM = 'Regenerating replaces the current key. ' +
  'Anyone still holding the old key will not be able to use it. Continue?';

/** Shows a newly generated ADP connector key once, with a Copy button. */
@Component({
    selector: 'app-connector-key-modal-component',
    standalone: false,
    template: `
  <div class="modal-header">
    <h4 class="modal-title" id="modal-title">ADP Connector key</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.close()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p><strong>Copy this key now. It will not be shown again. If you lose it, regenerate it; the old key stops working.</strong></p>
    <div class="input-group">
      <input #keyInput type="text" class="form-control" readonly [value]="connectorKey" (focus)="keyInput.select()">
      <div class="input-group-append">
        <button type="button" class="btn btn-primary" ngbAutofocus (click)="copy(keyInput)">{{ copied ? 'Copied' : 'Copy' }}</button>
      </div>
    </div>
    <p *ngIf="copyFailed" class="text-danger mt-2 mb-0">Copy failed. Select the key and copy it manually.</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-danger" (click)="modal.close()">Done</button>
  </div>
  `
})
export class ConnectorKeyModalComponent {
  @Input() connectorKey = '';

  copied = false;
  copyFailed = false;

  constructor(public modal: NgbActiveModal) {
  }

  /** Copies the key to the clipboard, falling back to execCommand where the Clipboard API is unavailable. */
  copy(input: HTMLInputElement) {
    this.copyFailed = false;
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(this.connectorKey).then(
        () => this.copied = true,
        () => this.copyWithSelection(input)
      );
    } else {
      this.copyWithSelection(input);
    }
  }

  /** Copies the key by selecting the input text and running the legacy copy command. */
  private copyWithSelection(input: HTMLInputElement) {
    input.select();
    input.setSelectionRange(0, this.connectorKey.length);
    try {
      this.copied = document.execCommand('copy');
    } catch {
      this.copied = false;
    }
    this.copyFailed = !this.copied;
  }
}
